import React, { FC } from "react";
import { Space, Typography } from "antd";
import { useTheme } from "../../../../Styles/ThemeHook";
import { BedIcon } from "shared-components/Components/CustomIcons/BedIcon/web";

interface RoomsTagProps {
	rooms: number;
	icon?: boolean;
	prefix?: boolean;
	isEspecial?: Boolean;
}

export const RoomsTag: FC<RoomsTagProps> = ({
	rooms,
	icon = false,
	prefix = false,
	isEspecial,
}) => {
	const { theme } = useTheme();

	if (!isEspecial && rooms === 0) return null;

	return (
		<div className="typology-item-container">
			{isEspecial ? (
				<>
					{icon && <BedIcon />}
					<div style={{ display: "flex", flexDirection: "column" }}>
						<Typography.Text className="name" ellipsis>
							Ambiente{rooms != 1 ? 's' : ''}
						</Typography.Text>
						<Typography.Text className="count" ellipsis>
							{prefix ? `${rooms}+` : rooms}
						</Typography.Text>
					</div>
				</>
			) : (
				<>
					{icon && <BedIcon />}
					<Typography.Text ellipsis>
						{rooms}{prefix ? "+" : ""} Ambiente{rooms != 1 ? 's' : ''}
					</Typography.Text>
				</>
			)}
		</div>
	);
};
